// removed by extract-text-webpack-plugin
module.exports = {"form":"FormContactDetail__form___1ZUH3","formButtons":"FormContactDetail__formButtons___3kP60","formButton":"FormContactDetail__formButton___u8blw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FormContactDetail/FormContactDetail.scss
// module id = 1178
// module chunks = 1